import { GiftCardType, giftCardTypeName } from 'corso-types';
import { SimpleSelect } from 'corso-admin-ui';

const giftCardTypeDescription = {
  [GiftCardType.giftCardOrder]:
    'A gift card that is created as an order in the system.',
  [GiftCardType.storeCredit]:
    'A gift card that is created as store credit to the Shopify customer account.',
  [GiftCardType.giftCard]:
    'A gift card that is emailed to the customer with a code and balance.',
} satisfies Record<GiftCardType, string>;

export default function GiftCardTypeSelect({
  value,
  onChange,
  error,
  allowStoreCredit = false,
}: {
  value: GiftCardType;
  onChange: (value: GiftCardType) => void;
  error?: string;
  allowStoreCredit?: boolean;
}) {
  const giftCardTypeOptions = Object.values(GiftCardType)
    .map((v) => ({
      label: giftCardTypeName[v],
      value: v,
    }))
    .filter((v) => allowStoreCredit || v.value !== 'Store_Credit');
  return (
    <SimpleSelect
      label="Gift Card Type"
      details={giftCardTypeDescription[value]}
      options={giftCardTypeOptions}
      value={value}
      onChange={onChange}
      error={error}
      disabled={value === 'Store_Credit'}
    />
  );
}
